export function getImgSrcWithSize(imgSrc: string | undefined, size: number) {
  // Size (e.g. format=i256x256) are added to imgSrc to instruct the backend to deliver a smaller image. Really small images
  // are however already included in the URI (data:image/png;base64,...) and should not have any additional format info.
  return imgSrc?.startsWith('data:')
    ? imgSrc
    : setQueryParam(imgSrc, 'format', `i${size}x${size}`);
}

function setQueryParam(url: string | undefined, name: string, value: string) {
  if (!url) {
    return url;
  }
  const newUrl = new URL(url);
  newUrl.searchParams.set(name, value);
  return newUrl.toString();
}
